import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const ToTop24 = ({
  height = 24,
  width = 24,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M12.0477 5C12.3985 5 12.6992 5.15123 12.8996 5.40329L17.7606 10.9485C18.1114 11.3014 18.0613 11.9063 17.7105 12.2592C17.3597 12.6121 16.7584 12.5617 16.4076 12.2088C16.4076 12.2088 16.4076 12.2088 16.3575 12.1584L12.0978 7.31891C12.0477 7.2685 11.9976 7.2685 11.8974 7.31891L7.63776 12.1584C7.28696 12.5617 6.73572 12.6121 6.33481 12.2592C5.93391 11.9063 5.88379 11.3518 6.23459 10.9485C6.23459 10.9485 6.23459 10.9485 6.2847 10.8981L11.1457 5.35288C11.3962 5.15123 11.6969 5 12.0477 5Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M12.0477 11.5C12.3985 11.5 12.6992 11.6512 12.8996 11.9033L17.7606 17.4485C18.1114 17.8014 18.0613 18.4063 17.7105 18.7592C17.3597 19.1121 16.7584 19.0617 16.4076 18.7088C16.4076 18.7088 16.4076 18.7088 16.3575 18.6584L12.0978 13.8189C12.0477 13.7685 11.9976 13.7685 11.8974 13.8189L7.63776 18.6584C7.28696 19.0617 6.73572 19.1121 6.33481 18.7592C5.93391 18.4063 5.88379 17.8518 6.23459 17.4485C6.23459 17.4485 6.23459 17.4485 6.2847 17.3981L11.1457 11.8529C11.3962 11.6512 11.6969 11.5 12.0477 11.5Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
